import styled from "styled-components";

export const UserSelectModalContainer = styled.div`
  .filters_parent {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin-top: 15px;
    gap: 15px;
  }

  .list_parent {
    max-height: 40vh;
    margin-top: 20px;
    overflow-y: scroll;
    padding-left: 10px;
  }

  .submit_parent {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin-top: 20px;

    .close_btn,
    .submit_btn {
      width: 200px;
    }
  }

  @media (max-width: 1000px) {
    .filters_parent {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 426px) {
    .filters_parent {
      grid-template-columns: repeat(1, 1fr);
    }

    .submit_parent {
      gap: 10px;
      flex-direction: column;

      .close_btn,
      .submit_btn {
        width: 100%;
      }
    }
  }
`;
